import React from 'react';

class Checkbox extends React.Component {

    getLabelContent() {
        if(this.props.children) {
            return (this.props.children);
        }
        return (
            (<span>
                {this.props.label}
                {this.props.disabledReason ? " - " + this.props.disabledReason : ""}
            </span>)
        );
    }
    render()
    {
        return (
            <div className="base-checkbox">
                <label className={"flex inline-flex items-center select-none" + (this.props.disabled ? " disabled" : "")}>
                    <input
                        type="checkbox"
                        value={this.props.value || this.props.label}
                        onChange={this.props.handleCheckboxChange}
                        checked={this.props.checked}
                        disabled={this.props.disabled}
                    />
                    <span className="checkbox-indicator shrink-0"></span>
                    <div className="inline">
                        {this.getLabelContent()}
                    </div>
                </label>
            </div>
        )
    }
}

export default Checkbox;